/**
 * @description {博客栏目 相关接口 }
 */
import { api } from '@/utils/http'

const SECTION_LIST = '/section/list'
const SECTION_ADD = '/section/add'
const SECTION_UPDATE = '/section/update'
const SECTION_DEL = '/section/del'
const SECTION_TREE = '/section/tree'

export function sectionList(data){
    return api({url:SECTION_LIST, method:'POST', data})
}

export function sectionAdd(data){
    return api({url:SECTION_ADD, method:'POST', data})
}

export function sectionUpdate(data){
    return api({url:SECTION_UPDATE, method:'POST', data})
}

export function sectionDel(data){
    return api({url:SECTION_DEL, method:'POST', data})
}

export function sectionTree(data){
    return api({url:SECTION_TREE, method:'POST', data})
}